import { render, staticRenderFns } from "./storageRegister.vue?vue&type=template&id=9b5dbb5c&scoped=true&"
import script from "./storageRegister.vue?vue&type=script&lang=js&"
export * from "./storageRegister.vue?vue&type=script&lang=js&"
import style0 from "./storageRegister.vue?vue&type=style&index=0&id=9b5dbb5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5dbb5c",
  null
  
)

export default component.exports